import { downgradeComponent } from "@angular/upgrade/static";
import { TagFormComponent } from "@webapp/tags/components/tag-form/tag-form.component";
import { TagStatusComponent } from "@webapp/tags/components/tag-status/tag-status.component";
import { MergeTagsCompoent } from "./components/merge-tags/merge-tags.component";
import { TagCellCompoent } from "./components/tag-cell/tag-cell.component";
import { TagsGridComponent } from "./components/tags-grid/tags-grid.component";

const mod = angular.module("tags", []);
mod.component("tagsGrid", TagsGridComponent);
mod.component("tagCell", TagCellCompoent);
mod.component("mergeTags", MergeTagsCompoent);
mod.directive("tagForm", downgradeComponent({ component: TagFormComponent }));
mod.directive("tagStatus", downgradeComponent({ component: TagStatusComponent, inputs: ["tag"] }));

export default mod.name;
